$plhrable-color: MenuText !default;
$plhrable-placeholder-color: gainsboro !default;

/* Dropdown colors */

.af-plhrable {
  option {
    color: $plhrable-color;
  }

  option:first-child,
  &--placeholder,
  &--placeholder:focus {
    color: $plhrable-placeholder-color;
  }
}
